import { Chip } from '@mui/material';

type Tone = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';

/** Meaning-coded colours for document and record statuses used across the API. */
const TONES: Record<string, Tone> = {
  DRAFT: 'default',
  OPEN: 'info',
  CONFIRMED: 'info',
  SENT: 'info',
  ACCEPTED: 'success',
  POSTED: 'success',
  ISSUED: 'success',
  COMPLETED: 'success',
  DELIVERED: 'success',
  RECEIVED: 'success',
  PAID: 'success',
  ACTIVE: 'success',
  TRIAL: 'primary',
  PARTIALLY_PAID: 'warning',
  PARTIALLY_DELIVERED: 'warning',
  PARTIALLY_RECEIVED: 'warning',
  PARTIAL: 'warning',
  UNPAID: 'warning',
  OVERDUE: 'error',
  GRACE: 'warning',
  EXPIRED: 'error',
  REJECTED: 'error',
  CANCELLED: 'error',
  VOID: 'error',
  VOIDED: 'error',
  SUSPENDED: 'error',
  INACTIVE: 'default',
  CONVERTED: 'primary',
};

export function humanize(value: string): string {
  const s = value.replace(/_/g, ' ').toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function StatusChip({ status, label }: { status: string; label?: string }) {
  const tone = TONES[status.toUpperCase()] ?? 'default';
  return (
    <Chip
      size="small"
      label={label ?? humanize(status)}
      color={tone === 'default' ? 'default' : tone}
      variant={tone === 'default' ? 'outlined' : 'filled'}
      sx={
        tone === 'default'
          ? undefined
          : (t) => {
              const p = (t.vars ?? t).palette[tone];
              const c = p.main;
              return {
                bgcolor: `color-mix(in srgb, ${c} 12%, transparent)`,
                // The darker shade keeps 12 px text at 4.5:1 on the tint (also on hovered rows).
                color: p.dark,
                border: `1px solid color-mix(in srgb, ${c} 22%, transparent)`,
                ...t.applyStyles('dark', { color: c }),
              };
            }
      }
    />
  );
}
